export default "__VITE_ASSET__BQRLTFDP__"